import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faCog } from '@fortawesome/free-solid-svg-icons';
import './SidebarMenuDropdown.css';

const SidebarMenuDropdown = ({ visible, onMenuSelect, selectedMenu }) => {
  if (!visible) return null;
  return (
    <div className="sidebar-dropdown">
      <ul className="sidebar-dropdown-list">
        
        
        <li className={`sidebar-dropdown-item${selectedMenu === 'CoursesInPlace' ? ' active' : ''}`} onClick={() => onMenuSelect && onMenuSelect('CoursesInPlace')}>
          <span className="sidebar-dropdown-icon" role="img" aria-label="Courses"><FontAwesomeIcon icon={faBook} /></span>
          Cursuri
        </li>
        <hr className="sidebar-dropdown-divider" />
        <li className={`sidebar-dropdown-item${selectedMenu === 'Setari' ? ' active' : ''}`} onClick={() => onMenuSelect && onMenuSelect('Setari')}>
          <span className="sidebar-dropdown-icon" role="img" aria-label="Settings"><FontAwesomeIcon icon={faCog} /></span>
          Setari
        </li>
        <li className="sidebar-dropdown-item">Ajutor</li>
        <li className="sidebar-dropdown-item">Deconectare</li>
      </ul>
    </div>
  );
};

export default SidebarMenuDropdown;
